export const ItemAnalysisTab = {
  QBankOverview: 'qbank-overview',
  ResponseStatistics: 'response-statistics',
  DiscriminantAnalysis: 'discriminant-analysis',
  PAnalysis: 'p-analysis',
} as const;

export type ItemAnalysisTabType = (typeof ItemAnalysisTab)[keyof typeof ItemAnalysisTab];

export const MINIMUM_DISPLAY_CHOICE = 5;

export const DEFAULT_HARD_THRESHOLD = 0.4;
export const DEFAULT_MEDIUM_THRESHOLD = 0.7;
export const DEFAULT_EASY_THRESHOLD = 1;
